// extracted by mini-css-extract-plugin
module.exports = {"sms-code-content":"sms-code-content___paI_9","sms-code-btn":"sms-code-btn___sZwJQ"};